/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Closing_Scene_3Inputs */

const en_closing_scene_3 = /** @type {(inputs: Closing_Scene_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you reach for your phone`)
};

const de_closing_scene_3 = /** @type {(inputs: Closing_Scene_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor dem Einschlafen`)
};

const zh_tw_closing_scene_3 = /** @type {(inputs: Closing_Scene_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在想滑手機時`)
};

const zh_cn_closing_scene_3 = /** @type {(inputs: Closing_Scene_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在想刷手机时`)
};

const es_closing_scene_3 = /** @type {(inputs: Closing_Scene_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando te dan ganas de revisar el móvil`)
};

const fr_closing_scene_3 = /** @type {(inputs: Closing_Scene_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dans un moment de scroll`)
};

const it_closing_scene_3 = /** @type {(inputs: Closing_Scene_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In attesa`)
};

const pt_br_closing_scene_3 = /** @type {(inputs: Closing_Scene_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No celular`)
};

const ja_closing_scene_3 = /** @type {(inputs: Closing_Scene_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ふとした空き時間に`)
};

const ko_closing_scene_3 = /** @type {(inputs: Closing_Scene_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`폰 만지작거릴 때`)
};

const ru_closing_scene_3 = /** @type {(inputs: Closing_Scene_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Когда тянет к телефону`)
};

const th_closing_scene_3 = /** @type {(inputs: Closing_Scene_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตอนอยากไถมือถือ`)
};

const tr_closing_scene_3 = /** @type {(inputs: Closing_Scene_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefona uzanırken`)
};

const ar_closing_scene_3 = /** @type {(inputs: Closing_Scene_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أثناء الرغبة في تصفّح الهاتف`)
};

/**
* | output |
* | --- |
* | "When you reach for your phone" |
*
* @param {Closing_Scene_3Inputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const closing_scene_3 = /** @type {((inputs?: Closing_Scene_3Inputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Closing_Scene_3Inputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_closing_scene_3(inputs)
	if (locale === "de") return de_closing_scene_3(inputs)
	if (locale === "zh_tw") return zh_tw_closing_scene_3(inputs)
	if (locale === "zh_cn") return zh_cn_closing_scene_3(inputs)
	if (locale === "es") return es_closing_scene_3(inputs)
	if (locale === "fr") return fr_closing_scene_3(inputs)
	if (locale === "it") return it_closing_scene_3(inputs)
	if (locale === "pt_br") return pt_br_closing_scene_3(inputs)
	if (locale === "ja") return ja_closing_scene_3(inputs)
	if (locale === "ko") return ko_closing_scene_3(inputs)
	if (locale === "ru") return ru_closing_scene_3(inputs)
	if (locale === "th") return th_closing_scene_3(inputs)
	if (locale === "tr") return tr_closing_scene_3(inputs)
	return ar_closing_scene_3(inputs)
});